import { render, staticRenderFns } from "./TechpacksList.vue?vue&type=template&id=333ffa42"
import script from "./TechpacksList.vue?vue&type=script&lang=ts"
export * from "./TechpacksList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports